<template lang="pug">
.order_report_list
  .header_title(slot="title") 选择订单
    .fr
      .el-btn(@click="back" style="width: 80px;")
        i.el-icon-arrow-left
        | 返回
      .el-btn(@click="isDownList = true") 任务列表
      .el-btn(@click="downReport") 下载报告
      .el-btn.red(@click="submit") 在线查看
  .choose_order
    .s_top
      ListSearchCpReport(@change="searchOrReset" ref="searchCp")

    .table
      el-table(
        ref="orderTable"
        border
        highlight-current-row
        height="calc(100% - 60px)"
        size="mini"
        :data="tableData"
        :row-class-name="rowClass"
        :cell-class-name="cellClass"
        @selection-change="currentChange")
        el-table-column(width="40" type="selection" :selectable="selectable" :indeterminate="false")
        el-table-column(label="订单编号" prop="orderCode" min-width="90px" align="center")
        el-table-column(label="广告名称" prop="contentName" min-width="100px" align="center")
        el-table-column(label="创建人" prop="creatorName" min-width="80px" align="center")
        el-table-column(label="广告类型" min-width="80px" align="center")
          template(slot-scope="{row}")
            span {{contentLevelStr(row.contentLevel)}}
        el-table-column(label="订单状态" prop="orderStatusName" min-width="80px" align="center")

        el-table-column(label="投放日期" prop="createTime" min-width="80px" align="center")
          template(slot-scope="{row}")
            span(v-if="row.startDate && row.endDate")
              span(v-if="row.startDate == row.endDate") {{row.startDate.replace(/-/g, '.')}}
              span(v-else)
                span(v-if="row.startDate.slice(0,5) == row.endDate.slice(0,5)") {{row.startDate.replace(/-/g, '.')}}-{{row.endDate.replace(/-/g, '.').slice(5)}}
                span(v-else) {{row.startDate.replace(/-/g, '.')}}-{{row.endDate.replace(/-/g, '.')}}

        el-table-column(label="数据存储（天）" prop="pictureStorageDays" min-width="80px" align="center")
        el-table-column(label="合同编码" prop="contractCode" min-width="80px" align="center")
        el-table-column(label="套餐兑换码" prop="packageInfoCode" min-width="80px" align="center")
        el-table-column(label="计费方式" prop="valuationType" min-width="80px" align="center")
          template(slot-scope="{row}")
            span {{valuationTypeStr(row.valuationType)}}
        el-table-column(label="订单信息" prop="amount" min-width="80px" align="center")
          template(slot-scope="{row}") 覆盖{{row.nbhdCount}}个小区、{{row.deviceCount}}个屏

      Pagination.page_box(v-if="pageInfo.total" :total="pageInfo.total" :page-sizes="[30,50,100,300]" :current-page.sync="pageInfo.current" :size.sync="pageInfo.size" :autoLoad="false" @fn-change="getList")

  fix-centerv1.down_report_box(v-model="isDownReport" w="600" h="530")
    span(slot="title") 下载报告
    .down_report(slot="main")
      .part
        .d_top 选择下载内容（多选）
          .fr
            el-dropdown(@command="handleSL" style="margin-right: 20px;cursor: pointer;")
              span
                | {{ isSL == 1 ? '上链' : '非上链' }}
                i.el-icon-caret-bottom.el-icon--right
              el-dropdown-menu(slot="dropdown")
                el-dropdown-item(
                  v-for="(item, i) in chainItems" :key="i"
                  :command="i" :style="{ color: isSL == i ? '#FF3973' : '' }"
                ) {{item}}
        .d_main
          MutexContentCheckbox(:options="contentOpts" :templateType.sync="reportType" v-model="contentList" @change="selectDownItems")
      .part
        .d_top 选择下载方式（单选）
        .d_main
          el-radio-group(v-model="downOpt.taskType")
            el-radio(v-for="(dw) in downWayItems" :key="dw.label" :label="dw.label" :disabled="dw.forbid") {{ dw.name }}

      .part
        .d_top 选择计算方式（单选）
        .d_main
          el-radio-group(v-model="downOpt.computeType")
            el-radio(:label="1") 订单之间汇总计算
            //- el-radio(:label="2") 订单之间独立计算
            //- el-radio(v-for="(item, i) in downCalcItems" :key="i" :label="i + 1") {{item}}
      .part
        .d_top 输入任务名称
        .d_main
          el-input(v-model="downOpt.name" placeholder="请输入（30个汉字以内）")

    .footer(slot="btm")
      .el-btn.red(@click="downFn") 确定
      .el-btn(@click="isDownReport = false") 关闭

  fix-centerv1.down_list_box(v-model="isDownList" w="580" h="625")
    span(slot="title") 下载列表
    .down_list_main(slot="main")
      div(style="text-align: center;")
        el-input.search(v-model="downListSearchStr" placeholder="输入任务名称" clearable size="mini")
          i.el-icon-search(slot="append" @click="() => { downListPageInfo.current = 1; getDownList() }")
      .data-none(v-if="downListTableData.length == 0") 暂无数据
      .down_list
        .down_list_item(v-for="(item, i) in downListTableData" :key="i")
          .dl_name {{item.name}}
          .dl_time {{item.createTime}}
            .fr
              .green(v-if="item.state === 2") 已完成
              .yellow(v-else-if="item.state === 1 || item.state === 5") 进行中（预计30分钟）
              template(v-else-if="item.state === 3") 已取消
              .wrong_red(v-else="item.state === 4") 发生错误，请联系管理员
          .dl_btm
            .btm_top
              .blue.down(v-if="item.state === 2 || item.state === 5" @click="getUrlList(item.id)") 下载任务
              span(v-if="item.state === 3" @click="delDownTask(item.id)") 删除任务
              .blue(v-if="item.state === 1 || item.state === 5" @click="updateTask(item)") 终止任务
              .blue(v-if="item.state === 4" @click="updateTask(item)") 重试任务

              .fr(@click="taskDetail(item)") 任务详情
                i(:class="[item.open ? 'el-icon-caret-top' : 'el-icon-caret-bottom']")
            .btm_main(v-if="item.open")
              div(style="margin-bottom: 10px;color: #282729;") 包含内容：{{item.contents}}
              div(v-if="item.taskType" style="margin-bottom: 10px;color: #282729;") 下载方式：{{(item.taskType || '').split(',').map(el => downWayItems[el - 1].name).join(',')}}
              div(style="margin-bottom: 10px;color: #282729;") 计算方式：{{((item.computeType || '') + '').split(',').map(el => downCalcItems[el - 1]).join(',')}}
              .btm_list
                .half.els(v-for="({orderCode, contentName}) in item.orderTaskDetailRes" :key="orderCode") {{orderCode}}
                  span.ad_name(:title="contentName") {{contentName}}

      el-pagination.page(
        layout="prev, pager, next"
        :total="downListPageInfo.total" :current-page.sync="downListPageInfo.current" :page-size="downListPageInfo.size"
        @current-change="getDownList"
      )
    .footer(slot="btm")
      button(class="close_button" @click="isDownList = false" style="margin-left: 0;") 关闭
  fix-centerv1.down_report_box(v-model="downUrl" w="580" h="520")
    span(slot="title") 下载链接
    div(slot="main")
      .report_item(v-for="(tj, j) in urlList" :key="j")
        .rt_name {{ tj.urlName }}：
        div
          .ut_item(v-for="(ut, k) in tj.subRes" :key="k")
            .url_msg(:class="{'disable': ut.message? true : false }" @click="downloadAction(ut)") {{ ut.message ? ut.message : ut.url }}
            el-popover(popper-class="url_btn_popover" trigger="hover" placement="top") 下载
              template(slot="reference")
                i(:class="['iconfont','icon-xiazaijietu',{'disable': btnDisable(ut.message)}]" @click="downloadAction(ut)")
            el-popover(popper-class="url_btn_popover" trigger="hover" placement="top") 复制链接
              template(slot="reference")
                i(:class="['iconfont','icon-copy',{'disable': btnDisable(ut.message)}]" @click="copyUrl(ut)")
    .footer(slot="btm")
      .el-btn(@click="downUrl = false") 关闭

  fix-centerv1.mess_tip(v-dialogDrag v-model="mesTip" w="400" h="300")
    template(slot="title") 温馨提示
    template(slot="main")
      .tip_ct
        span 已选中的订单涉及
        span(class="stress") 两个数据源
        span ，无法支持合并查看及下载报告的功能，请分别合并查看或下载报告。
      .ware_house
        span.new 新数据源
        span.old 旧数据源
    template(slot="btm")
      .fix-btn(size="mini" @click="mesTip = false") 关闭
</template>

<script>
import Pagination from '@/components/Pagination'
import { deepClone } from '@/utils/functions'
import { getReportOrderList } from '@/utils/api'
import DatePickerRanger from '@/components/DatePicker/Range'
import ListSearchCpReport from '@/components/ListSearchCpReport'
import MutexContentCheckbox from './MutexContentCheckbox'

const OptionList = [
  { label: 1, name: '数据报告', reportTemp: true, disabled: false },
  // { label: 2, name: '存证证书', disabled: false },
  { label: 3, name: '流量抓图', disabled: false },
  { label: 4, name: '上刊报告', disabled: false },
  { label: 5, name: '查刊报告', disabled: false, mutex: true }
]
const ContentType2Name = OptionList.reduce((tmap,o) => {
  tmap.set(o.label, o.name)
  tmap.set(o.label.toString(), o.name)
  return tmap
}, new Map())

const DownWays = [
  { label: 1, name: '汇总', forbid: false },
  { label: 2, name: '分城市', forbid: false },
  { label: 3, name: '分天', forbid: false }
]

export default {
  name: 'OrderReportMake',
  components: { Pagination, DatePickerRanger, ListSearchCpReport, MutexContentCheckbox },
  props: {
    value: {
      type: Boolean,
      default() {
        return false
      }
    },
    chooses: Array,
    isMorePageChoose: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      tableData: [],
      currentRow: [],
      pageInfo: { current: 1, size: 30, total: 0 },
      orderDetail: { timeSlots: '' },
      searchObj: { searchTime: [], contentName: '' },
      searchOpt: {},
      isDownReport: false,
      downContentItems: ['数据报告', '存证证书', '流量抓图', '上刊报告'],
      downWayItems: DownWays,
      downCalcItems: ['订单之间汇总计算', '订单之间独立计算'],
      contentOpts: OptionList,
      contentList: [],
      reportType: 1, // 数据报告模板,默认CPD
      reportTemplates: [
        { label: 'CPD模板', value: 1 },
        { label: 'CPR模板', value: 2 }
      ],
      downOpt: { name: '', taskType: null, computeType: 1 },

      isDownList: false,
      downListTableData: [],
      downListSearchStr: '',
      downListPageInfo: { current: 1, size: 20, total: 0 },
      urlList: [], // 分包下载各报告链接集合
      downUrl: false,

      isSL: 0, // 是否上链
      contentLevelList: [], // 广告类型列表
      valuationTypeList: [], // 计费方式列表
      mesTip: false
    }
  },
  computed: {
    contentLevelStr() {
      let list = this.contentLevelList
      return (v) => {
        if (v !== null && v !== undefined) {
          let item = list.filter((el) => el.dictItemCode == v)[0]
          return item ? item.dictItemName || '' : ''
        }
        return ''
      }
    },
    valuationTypeStr() {
      let list = this.valuationTypeList
      return (v) => {
        if (v !== null && v !== undefined) {
          let item = list.filter((el) => el.code == v)[0]
          return item ? item.value || '' : ''
        }
        return ''
      }
    },
    chainItems() {
      const len = this.currentRow.length
      if (!len) return ['非上链']
      const chains = this.currentRow.filter((r) => r.chainFlag === 1)
      return chains.length === len ? ['非上链', '上链'] : ['非上链']
    },
    visible: {
      get() {
        return this.value
      },
      set() {
        this.$emit('input', false)
      }
    },
    adUser() {
      return this.$store.state.customer.userInfo
    },
    cusId() {
      return this.adUser.customerId
    },
    // 存在流量抓图数据已过期的订单,禁用流量抓图选项
    picExpired() {
      return this.currentRow.some((e) => e.noFlowCapture)
    }
  },
  watch: {
    picExpired(v) {
      const [dp, pic, ...other] = this.contentOpts
      const tmp = deepClone({ ...pic, disabled: v })
      this.contentOpts = [dp, tmp, ...other]
    },
    chainItems(v) {
      this.isSL == 0
    },
    isDownList(v) {
      if (!v) {
        this.downListSearchStr = ''
      } else {
        this.downListPageInfo.current = 1
        this.getDownList()
      }
    },
    isDownReport(v) {
      if (!v) {
        this.contentList = []
        this.setContentOptions()
        this.downWayItems = DownWays
        this.reportType = 1
        this.downOpt.contentType = ''
        this.downOpt.taskType = null
        this.downOpt.computeType = 1
        this.downOpt.name = ''
        this.isSL = 0
      }
    },
    contentList(v) {
      this.downOpt.contentType = v.join(',')
    },
    async visible(val) {
      if (!val) {
        this.resetData()
      }
    },
    downUrl(v) {
      // 关闭分包下载弹窗后刷新任务列表(因为任务状态有可能已变更)
      if (!v) this.getDownList()
    },
    value(v) {
      if (v) {
        this.$nextTick(() => {
          this.$refs.searchCp.handleMoreShow() // 搜索条件中 更多按钮展示的处理
        })
      }
    }
  },
  async created() {
    this.getContentLevelList()
    this.getValuationTypeList()
  },
  methods: {
    // 2024-09-20 订单是否可选标志：后台返回false时禁用表格行checkbox功能，避免全选当前页时勾选上该订单
    selectable(row, _index) {
      return row.canSelect
    },
    async getContentLevelList() {
      let data = this.$store.state.common.CONTENTPLAYTYPE
      if (!data || data.length == 0) {
        const list = await this.$store.dispatch('getContentPlayType')
        this.contentLevelList = list
      } else {
        this.contentLevelList = data
      }
    },
    async getValuationTypeList() {
      let data = this.$store.state.common['GGDICT1080']
      if (!data || data.length == 0) await this.$store.dispatch('getDictListV2', '1080')
      let list = this.$store.state.common['GGDICT1080']
      if (typeof list == 'string') list = JSON.parse(list)
      this.valuationTypeList = list
    },
    handleSL(data) {
      this.contentList = []
      this.setContentOptions()
      this.downWayItems = DownWays
      this.isSL = data
    },
    back() {
      this.resetData()
      this.$emit('input', false)
    },
    resetData() {
      // 2023-03-22 V4.23.0 触发下载报告或在线查看报告保留选择订单界面状态
      // this.$refs.searchCp.reset();
      // this.searchOpt = {};
      // this.tableData = [];
    },
    searchOrReset(data, isReset) {
      this.searchOpt = data
      if (isReset) {
        this.currentRow = []
      }
      this.getList(1)
    },
    // 获取任务详情数据(之前未获取过才发请求)
    async taskDetail(task) {
      task.open = !task.open
      if (!task.hasDetail) {
        const res = await this.fetch('/chain/orderTask/getOrderTask', { taskId: task.id }, 'get')
        if (res && res.code == this.successCode && res.data) {
          task.hasDetail = true
          const { contentType = '', orderTaskDetailRes } = res.data || {}
          const contents = contentType.split(',').map(e => ContentType2Name.get(e)).join(',')
          this.$set(task, 'contents', contents)
          this.$set(task, 'orderTaskDetailRes', orderTaskDetailRes || [])
        } else {
          this.messageTip((res && res.masg) || '获取详情失败，请稍后再试')
        }
      }
    },
    delDownTask(taskId) {
      this.$confirm('此操作将删除任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async (vv) => {
          const res = await this.fetch('/chain/orderTask/update', { taskId, state: 0, customerId: this.cusId }, 'post')
          if (res && res.code == this.successCode) {
            this.messageTip(res.msg || '操作成功', 1)
            this.downListPageInfo.current = 1 // 返回第一页，以免是删除的非第一页的最后一条数据
            this.getDownList()
          } else this.messageTip((res && res.msg) || '操作失败')
        })
        .catch(() => { })
    },
    async updateTask({ state, id }) {
      const mapState = { 1: 3, 4: 1, 5: 3 }
      const res = await this.fetch(
        '/chain/orderTask/update',
        {
          taskId: id,
          state: mapState[state],
          customerId: this.cusId
        },
        'post'
      )
      if (res && res.code === this.successCode) {
        this.messageTip(res.msg || '操作成功', 1)
        this.getDownList()
      }
    },
    async getUrlList(taskId) {
      const res = await this.fetch('/chain/orderTask/getUrls', { taskId }, 'get')
      if (res && res.code === this.successCode) {
        this.urlList = res.data || []
        this.downUrl = true
      }
    },
    btnDisable(desc) {
      // 未完成状态禁用下载和复制链接按钮
      return Boolean(desc)
    },
    downloadAction({ url, message }) {
      if (this.btnDisable(message)) return
      if (url) {
        window.open(url)
      } else {
        console.warn('分包下载链接为空:', url, message)
      }
    },
    copyUrl({ url, message }) {
      if (this.btnDisable(message)) return
      const input = document.createElement('input')
      input.setAttribute('style', 'height:0')
      input.setAttribute('value', url)
      document.body.appendChild(input)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.messageTip('复制成功', 1)
      } else {
        console.warn('您的浏览器不支持复制功能')
      }
      document.body.removeChild(input)
    },
    // 重置下载内容选项,流量抓图是否禁用需依据picExpired
    setContentOptions() {
      const [dp, pic, ...other] = OptionList
      const tmp = deepClone({ ...pic, disabled: this.picExpired })
      this.contentOpts = [dp, tmp, ...other]
    },
    selectDownItems(v) {
      // 【查刊报告】与其他下载内容选项为互斥关系
      if (v.indexOf(5) > -1) {
        this.contentList = [5]
        const publish = this.contentOpts.filter(e => e.label === 5)
        const rest = this.contentOpts.filter(e => e.label !== 5)
        const tmp = rest.map(e => {
          return { ...e, disabled: true }
        })
        this.contentOpts = [...tmp, ...publish]

        // 选中“查刊报告”,下载方式只有“分天”可选
        const byDay = DownWays.filter(e => e.label === 3)
        const waysTmp = DownWays.filter(e => e.label !== 3).map(e => {
          return { ...e, forbid: true }
        })
        this.downWayItems = [...waysTmp, ...byDay]
        this.downOpt.taskType = 3
        this.reportType = null // 重置数据报告模板
      } else {
        this.setContentOptions()

        // 下载内容选中除“查刊报告”之外的选项,下载方式禁用“分天”
        if (v.length) {
          const waysTmp = DownWays.filter(e => e.label !== 3)
          const byDay = DownWays.filter(e => e.label === 3).map(e => {
            return { ...e, forbid: true }
          })
          this.downWayItems = [...waysTmp, ...byDay]
          // 若之前选中“分天”下载方式，则需重置
          if (this.downOpt.taskType === 3) {
            this.downOpt.taskType = null
          }
        } else {
          // 下载内容未勾选任何选项,重置下载方式、数据报告模板
          this.downWayItems = DownWays
          this.downOpt.taskType = null
          this.reportType = 1
        }
      }
    },
    async downFn() {
      let opt = this.downOpt
      if (!opt.contentType) return this.messageTip('请选择下载内容后再保存', 2)
      if (opt.contentType.indexOf('1') > -1 && !this.reportType) return this.messageTip('请选择数据报告模板后再保存', 2)
      if (!opt.taskType) return this.messageTip('请选择下载方式后再保存', 2)
      if (!opt.computeType) return this.messageTip('请选择计算方式后再保存', 2)
      if (!opt.name || opt.name.trim() == '') return this.messageTip('请输入任务名称后再保存', 2)
      if (opt.name.trim().length > 30) return this.messageTip('任务名称须30字符以内', 2)
      let deviceCounts = 0
      let nbhdCounts = 0
      this.currentRow.forEach((el) => {
        deviceCounts += el.deviceCount || 0
        nbhdCounts += el.nbhdCount || 0
      })
      const res = await this.fetch(
        '/chain/orderTask/save',
        {
          ...this.downOpt,
          reportType: this.reportType,
          name: opt.name.trim(),
          warehouse: this.currentRow[0] ? this.currentRow[0].dataWarehouse : true,
          orderReqList: this.currentRow.map((el) => ({
            contentName: el.contentName,
            orderCodes: el.orderCode,
            orderType: el.orderType,
            startDate: el.startDate,
            endDate: el.endDate,
            pictureExpirationTime: el.pictureExpirationTime,
            deviceCount: el.deviceCount || 0,
            nbhdCount: el.nbhdCount || 0
          })),
          customerId: this.cusId,
          chainFlag: this.isSL == 1 ? 1 : 2, // 1:上链 2:非上链
          deviceCounts,
          nbhdCounts
        },
        'post'
      )
      if (res && res.code == this.successCode) {
        this.messageTip(res.msg || '操作成功', 1)
        this.isDownReport = false
        // 2023-03-22 V4.23.0 触发下载报告或在线查看报告保留选择订单界面状态
        // 操作成功 重置表格以及搜索条件
        // this.$refs.orderTable.clearSelection();
        // this.$refs.searchCp.reset();
      } else if (res.code === 900501) {
        this.messageTip(res.msg)
      }
    },
    rowClass(data) {
      if (!data.row.canSelect) return 'row-disabled' // 禁止选中该订单
      if (data.row.noFlowCapture) return 'row-grey' // 订单可选,但流量抓图禁用
      else return ''
    },
    cellClass({ row: { dataWarehouse }, columnIndex }) {
      if (columnIndex === 0) {
        // dataWarehouse-- true:新数据源,false:旧数据源
        return dataWarehouse ? 'new_ware' : 'old_ware'
      }
    },
    async getDownList() {
      const param = {
        name: this.downListSearchStr.trim(),
        pageIndex: this.downListPageInfo.current,
        pageSize: this.downListPageInfo.size,
        customerId: this.cusId
      }
      const res = await this.fetch('/chain/orderTask/getPage', param)
      if (res && res.code === this.successCode && res.data) {
        const data = res.data
        this.downListTableData = (data.list || []).map((el) => {
          el.open = false
          return el
        })
        this.downListPageInfo.total = data.total || 0
      }
    },
    async getList(page, notFistShowTable) {
      if (page && typeof page == 'number') this.pageInfo.current = page

      let param = {
        ...this.searchOpt,
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size
      }
      let load = this.$loading()
      let res = await getReportOrderList(param)
      load.close()

      let pagesChoose = this.currentRow // 临时存一下，不然清空tableData currentRow也会触发currentChange事件被清空 后续 处理进来默认选中 使用

      this.tableData = (res.data.list || []).map((el) => {
        // 新版本流量抓图是否可用根据有效时长来判断
        el.noFlowCapture = new Date() - new Date(el.pictureExpirationTime) > 0
        return el
      })
      this.pageInfo.total = res.data.total
      if (!notFistShowTable) {
        this.$nextTick(() => {
          // 处理选中状态
          let guids = this.tableData.map((el) => el.guid)
          pagesChoose &&
            pagesChoose.length &&
            pagesChoose
              .filter((el) => el)
              .forEach((row) => {
                let t = this.tableData[guids.indexOf(row.guid)]
                this.$refs.orderTable.toggleRowSelection(t)
              })
          this.currentRow = pagesChoose
        })
      }

      return this.tableData
    },
    currentChange(data) {
      if (this.isMorePageChoose) {
        // 如果是跨页选择
        this.morePageChoose(data)
      } else {
        this.currentRow = data
      }
    },
    morePageChoose(changeData) {
      changeData = changeData.filter((el) => el)
      const selGuid = changeData.map((ele) => ele.guid)
      let choose = JSON.parse(JSON.stringify(this.currentRow)) || [] // 这里需要深拷贝处理下
      const elGuids = choose.map((el) => el.guid)
      changeData.forEach((el) => {
        if (el && elGuids.indexOf(el.guid) == -1) choose.push(el)
      })
      const noChooseGuids = this.tableData.filter((el) => selGuid.indexOf(el.guid) == -1).map((r) => r.guid)
      choose.forEach((el, i) => {
        if (noChooseGuids.indexOf(el.guid) > -1) {
          choose[i] = null
        }
      })
      this.currentRow = choose.filter((e) => e)
    },
    downReport() {
      if (this.allow()) this.isDownReport = true
    },
    submit() {
      if (this.allow()) {
        this.$emit('get-result', this.currentRow)
        this.$emit('input', false)
      }
    },
    // 是否允许在线查看/下载报告
    allow() {
      if (!this.currentRow.length) {
        this.messageTip('请先选择订单后再操作～', 2)
        return false
      }
      if (this.currentRow.length > 30) {
        this.messageTip('最多选择30个订单哟～', 2)
        return false
      }
      const ware = this.currentRow.filter((o) => o.dataWarehouse).length
      if (ware > 0 && ware !== this.currentRow.length) {
        // 存在新数据源订单且数量不等于已勾选订单数,说明是不同数据源
        this.mesTip = true
        return false
      }
      return true
    }
  }
}
</script>

<style lang="sass">
.el-popover.url_btn_popover
  min-width: auto
</style>
<style lang="sass" scoped>
.order_report_list
  height: 100%
  background: #fff
  padding: 0 20px
.el-btn
  margin: 0 0 0 10px
  & + .el-btn
    margin-top: 0
.s_top
  margin-bottom: 10px
  position: relative
  z-index: 2
.header_title
  height: 65px
  padding-top: 17px
  font-weight: 600
  font-size: 18px
  line-height: 30px
  border-bottom: 1px solid #F5F5F5
  margin-bottom: 20px
  .fr
    font-weight: normal
    font-size: 14px
.mess_tip
  .tip_ct
    line-height: 20px
    margin-top: 35px
    padding: 0 10px
    text-align: center
    .stress
      color: #FF3973
      font-weight: bold
  .ware_house
    display: flex
    align-items: center
    justify-content: center
    line-height: 20px
    margin-top: 20px
    padding: 0 10px
    .new, .old
      position: relative
      color: #666666
      padding-left: 14px
      &::before
        content: ""
        position: absolute
        left: 0
        top: 3px
        bottom: 3px
        width: 4px
        background: #6296FF
    .old
      margin-left: 30px
      &::before
        background: linear-gradient(315deg, #FAEA61 0%, #FFB81F 100%)
.down_report_box, .down_list_box
  ::v-deep .fix-center-main
    background: #f5f5f5
.down_report
    background: #f5f5f5
    .part
      background: #fff
      border-radio: 4px
      &:not(::last-child)
        margin-bottom: 10px
    .d_top
      line-height: 50px
      padding-left: 20px
      font-size: 16px
      font-weight: bold
      border-bottom: 1px solid #E9E9E9
    .d_main
      padding: 20px
    ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label,
    ::v-deep .el-radio__input.is-checked+.el-radio__label
      color: inherit
    ::v-deep .el-radio__input.is-checked .el-radio__inner
      border-color: #FF3973
      background-color: #FF3973
.down_list_box.fix-center
  ::v-deep .fix-center-main
    padding: 0 10px
.down_list_main
    height: 100%
    ::v-deep .el-input.search
      border-radius: 30px
      margin: 10px auto
      width: 300px
      .el-input-group__append
        background-color: #fff
        border: none
        border-radius: 0 30px 30px 0
        cursor: pointer
        padding: 0 15px 0
      input
        border: none
        border-radius: 30px 0 0 30px
    .down_list
      height: calc(100% - 98px)
      overflow: auto
      .down_list_item
        font-size: 12px
        background: #fff
        border-radius: 4px
        color: #999
        margin-top: 5px
        .green
          color: #3FB536
        .blue
          color: #6296FF
          &.down
            margin-right: 5px
        .yellow
          color: #FF7413
        .wrong_red
          color: #D50000
        .dl_name
          font-size: 14px
          font-weight: bold
          line-height: 20px
          color: #282729
          padding: 12px 20px 0
          margin-bottom: 4px
        .dl_time
          padding: 0 20px
          line-height: 18px
          margin-bottom: 10px
        .dl_btm
          .btm_top
            padding: 0 20px
            line-height: 36px
            border-top: 1px solid #EAEBF0
            > div
              display: inline-block
              cursor: pointer
            .blue, span
              cursor: pointer
            .fr
              cursor: pointer
          .btm_main
            border-top: 1px solid #EAEBF0
            padding: 20px 20px 10px
            .btm_list
              margin: 0 -10px
              overflow: hidden
              .half
                margin: 0 5px 10px 5px
                float: left
                width: calc(50% - 10px)
                background: #F5F5F5
                line-height: 24px
                padding: 0 10px
              .ad_name
                margin-left: 10px

.page
  text-align: center
  margin-top: 10px
  ::v-deep .btn-next, ::v-deep .btn-prev
    background: inherit
  ::v-deep .el-pager
    li
      background: inherit
      &.active
        color: #FF3973

.report_item
    background: #FFF
    padding: 15px 18px
    display: flex
    justify-content: flex-start
    align-items: flex-start
    &:not(:first-child)
      margin-top: 10px
    .rt_name
      min-width: 70px
      font-weight: 600
    .ut_item
      &:not(:last-child)
        margin-bottom: 15px
      .url_msg
        display: inline-block
        color: #6296FF
        cursor: pointer
        line-height: 20px
        margin-right: 18px
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
        width: 360px
        &.disable
          color: #D4D4D4
      > span
        outline: none
        vertical-align: top
      .iconfont
        cursor: pointer
        font-size: 16px
        font-weight: 600
        line-height: 20px
        outline: none
      .icon-xiazaijietu
        margin-right: 18px
      .disable
        color: #D4D4D4
        cursor: not-allowed
.choose_order
  height: calc(100% - 85px)
  overflow: auto
  color: #282729
  .table
    height: calc(100% - 52px)
    position: relative
    z-index: 1
  ::v-deep .row-disabled
    color: #d4d4d4
    .el-checkbox
      display: none
  ::v-deep .el-table
    border-top: none
    .el-table__header
      background: #F1F1F1
      .cell
        border-right: 1px solid #D4D4D4
        color: #282729
      .is-leaf
        border-right: none
        background: #F1F1F1
    .el-table__row
      td
        padding: 10px 0
    .current-row td
      background: rgba(#FF3973, .2)
    .new_ware, .old_ware
      &::before
        content: ""
        position: absolute
        top: 3px
        bottom: 3px
        left: 0
        width: 3px
        background: #6296FF
    .old_ware::before
      background: linear-gradient(315deg, #FAEA61 0%, #FFB81F 100%)
    .row-grey .el-checkbox__input .el-checkbox__inner
      background-color: #edf2fc !important
      border-color: #dcdfe6 !important
      &::after
        border-color: #afb1b2

  .page_box
    height: 60px
    padding: 10px 20px
    bottom: 0
    border: 1px solid #E9E9E9
    border-top: none
.footer
  padding: 15px 0
  border-top: 1px solid #E9E9E9
  text-align: center
  .close_button
    width: 120px
    height: 30px
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%)
    border-radius: 4px
    border: none
    cursor: pointer
    color: #FFF
    outline: 0
    &:last-child
      border: 1px solid #d4d4d4
      background: #ffffff
      color: #282729
      margin-left: 20px
::v-deep .el-dialog
  border-radius: 8px
  .el-dialog__header
    padding: 12px 0
    border-bottom: 1px solid #E9E9E9
  .el-dialog__headerbtn
    top: 17px
    right: 17px
    font-weight: 600
    color: #282729
  .el-dialog__body
    padding: 20px
  .el-dialog__footer
    padding: 0
</style>
